class t{static set(t,e=!0){}static get(e){return t._traceChannels.has(e)}}t._traceChannels=new Set,t.stack=!1;export{t as Tracing};
